import { ReceptionInputSection, ReceptionDeliveryKind, ReceptionTypeItem, } from "../items";
import { ReceptionDispInfo } from "..";
import { ReceptionEditorInstantCloserSetting, ReceptionEditorPermissions } from ".";
import { ReceptionEditorInputUnitDispInfo } from "./ReceptionEditorInputUnitDispInfo";
import { ProgressConditionKinds, ReceptionCommentUnitKinds, ReceptionCommentSortItemKinds, } from "../kinds";


// 依頼作成・編集画面表示用model
export class ReceptionEditorDispInfo {
  constructor() {
    this.inputSectionList = [];
    this.relationshipList = [];
    this.paperNameList = [];
    this.deliveryKindList = [];
    this.labelSetting = new ReceptionDispInfo();
    this.permissions = new ReceptionEditorPermissions();
    this.contactNameList = [];
    this.receiptFormatOriginalIds = [];
    this.paymentStatusList = [];
  }

  // 入力部署選択肢リスト
  public inputSectionList: ReceptionInputSection[];

  // 続柄選択肢リスト
  public relationshipList: ReceptionTypeItem[];

  // 手書き文書名選択肢リスト
  public paperNameList: ReceptionTypeItem[];

  // ラベル表示設定
  public labelSetting: ReceptionDispInfo;

  // 対応責任者必須フラグ
  public isManagerRequired: boolean;

  // 対応責任者の入院歴使用有無
  public isHospitalizationHistoryEnable: boolean;

  // 対応責任者の来院歴使用有無
  public isVisitHistoryEnable: boolean;

  // フォーマット選択ダイアログ内の「すべて」タブを表示有無
  public isFormatSelectorAllTabEnable: boolean;

  // 権限リスト
  public permissions: ReceptionEditorPermissions;

  // 閲覧制限コメント権限有無
  public isRestrictCommentEnable: boolean;

  // コメントの編集権限有無
  public isCommentEditable: boolean;

  // 閲覧制限コメントの編集権限有無
  public isRestrictCommentEditable: boolean;

  // 伝達事項の編集権限有無
  public isNextMessageEditable: boolean;

  // 証明期間初期個数
  public proofPeriodDefaultCount: number;

  // 証明期間最大個数
  public proofPeriodMaxCount: number;

  // 各種項目の入力単位設定
  public inputUnitSetting: ReceptionEditorInputUnitDispInfo;

  // 交付方法の表示設定
  public deliveryKindList: ReceptionDeliveryKind[];

  // 記載設定の表示項目
  public displayProgressConditions: ProgressConditionKinds[];

  // デフォルトの記載設定
  public defaultProgressCondition: ProgressConditionKinds;

  // 依頼文書の上限個数
  public receptionDetailMaxCount: number;

  // 受領書の発行を行うかどうか
  public isPublishReceipt: boolean;

  // 受領書のフォーマット（現状では未指定もしくは先頭1つのみ対応可能）
  public receiptFormatOriginalIds: number[];

  // 受取日の初期値設定（初期値セットしない場合はnull）
  public ReceiptDateDefaultDays: number;

  // 連絡先の要・不要の初期値設定（初期値セットしない場合はnull）
  public defaultContactRequired: boolean;

  // 交付方法の初期値設定（初期値セットしない場合はnull）
  public defaultDeliveryTypeCode: number;

  // プロジェクトチーム選択時に診療科・対応責任者を自動入力する
  public shouldAutoApplyProjectTeamInfo: boolean;

  // 診療科を必須フラグ
  public isDepartmentRequired: boolean;

  // 診療科選択後に対応責任者選択画面を上げる
  public shouldSelectManagers: boolean;

  // 非表示にする診療科コード
  public nondisplayDepartmentCodeList: string[];

  // 受付・依頼を登録後に画面を閉じるかどうか
  public instantCloserSetting: ReceptionEditorInstantCloserSetting;

  // 手書きの入力
  public isPaperEnable: boolean;

  // 手書き文書名の入力
  public isPaperNameEnable: boolean;

  // 手書き会社名の入力
  public isPaperCompanyNameEnable: boolean;

  // コメントの管理単位(単数/複数)
  public commentMode: ReceptionCommentUnitKinds;

  // 伝達事項の管理単位(単数/複数)
  public nextMessageMode: ReceptionCommentUnitKinds;

  // 閲覧制限コメントの管理単位(単数/複数)
  public restrictCommentMode: ReceptionCommentUnitKinds;

  // 並び順のデフォルト
  public commentDefaultSortType: ReceptionCommentSortItemKinds;

  // コメントを登録できるかどうか
  public isCommentRegisterable: boolean;

  // 伝達事項を登録できるかどうか
  public isNextMessageRegisterable: boolean;

  // 閲覧制限コメントを登録できるかどうか
  public isRestrictCommentRegisterable: boolean;

  // 連絡先名称選択肢リスト
  public contactNameList: ReceptionTypeItem[];

  // 依頼引用・コピーで締切日を引用するかどうか
  public isWorkflowPhasesQuoteEnable: boolean;

  // 管理単位が複数でも依頼編集画面で編集できるようにするかどうか
  public isCommentEditableSingleUnitOnly: boolean;

  // コメントを昇順にするかどうか
  public shouldSortCommentAsc: boolean;

  // 代金受領状況選択肢リスト
  public paymentStatusList: ReceptionTypeItem[];

  // 対応責任者の氏名のあとに電話番号も表示するかどうか
  public shouldShowManagerPhoneNumber: boolean;
}
